import angular from 'angular';

export const CalendarServiceModule = angular.module('acme.common.service.calendar', [])
.service('CalendarService', [ '$filter', function($filter) {

  return {

    current: {},

    weekdays: {
      Su: {
        name: 'Sunday',
        number: 1
      },
      M: {
        name: 'Monday',
        number: 2
      },
      Tu: {
        name: 'Tuesday',
        number: 3
      },
      W: {
        name: 'Wednesday',
        number: 4
      },
      Th: {
        name: 'Thursday',
        number: 5
      },
      F: {
        name: 'Friday',
        number: 6
      },
      Sa: {
        name: 'Saturday',
        number: 7
      }
    },


    init: function() {
      return true;
    },

    create: function(eventData) {
      this.current = eventData;
    },

    getWeek: function(date, returnText) {
      console.log('getWeek', date);
      var r,
        d = new Date(date),
        week = parseInt((String((d.getDate() - 1) / 7)), 10) + 1;

      if (returnText) {
        switch (week) {
          case 1:
            r = "first";
            break;
          case 2:
            r = "second";
            break;
          case 3:
            r = "third";
            break;
          case 4:
            r = "fourth";
            break;
          case 5:
            r = "fifth";
            break;
        }
      }else{
        r = week;
      }

      return r;
    },

    toISO8601: function(date) {
      var format = 'yyyy-MM-ddTHH:mm:ssZ';

      return $filter('date')(date, format);
    },

    toMinutes: function(minute) {
      if (minute < 10) {
        return "0"+minute;
      }

      return minute;
    },

    getParsableDate: function(date) {

      var s = '',
          split,
          d = date;

      if ( d instanceof Date ) {
        if (isNaN(d.getTime())) {
          split = date.split(/[^0-9]/);
          d = new Date(split[0], split[1]-1, split[2], split[3], split[4], split[5]);
        }
      }else if ( typeof(d) === 'string' ) {
        split = date.split(/[^0-9]/);
        d = new Date(split[0], split[1]-1, split[2], split[3], split[4], split[5]);
      }

      return d;
    },

    toHour: function(hour) {
      var h = hour;

      if (h > 12) {
        h -= 12;
      }

      if (h === 0) {
        h = 12;
      }

      return h;
    },

    getMeridian: function(hour) {
      return (hour >= 12) ? 'PM' : 'AM';
    }

  };

}]).name;